import { atom } from 'jotai';

export const neLonAtom = atom<number>(0);
export const neLatAtom = atom<number>(0);
export const swLonAtom = atom<number>(0);
export const swLatAtom = atom<number>(0);
export const userLatAtom = atom<number>(0);
export const userLonAtom = atom<number>(0);

// ShopFilter 가 마운트 시 ''로 초기화하므로 초기값도 ''로 맞춰 queryKey 가 바뀌지 않게 한다
export const queryAtom = atom<string|undefined>('');

export const isMyShopAtom = atom<boolean>(false);
